import "reflect-metadata"; //needed for class-transformer

import "@pentacode/app/src/elements/admin/app.ts";
// uno resets and utilities for the page itself, so only entries that own the
// page load it (not the integration entry). Generated and untracked:
// eslint-disable-next-line import/no-unresolved
import "@pentacode/app/src/styles/uno.css";

import { initApp } from "@pentacode/app/src/init";

initApp({ mode: "standalone" });

const app = document.createElement("ptc-admin-app");
document.body.appendChild(app);
